import { connect } from 'react-redux';
import { sessionSelector } from '../reducers/session';
import * as React from 'react';

type StoreProps = {
  isFeatureFlagEnabled: boolean;
};

type OwnProps = {
  [otherProp: string]: any;
};

type Props = StoreProps & OwnProps;

/**
 * HOC that returns the wrapped component only if a certain feature flag is enabled
 * Careful when using in render method, only use when it shouldn't trigger re-rendering
 * like directly using with routes.
 * @param {string} featureFlag - the feature flag required to view the component
 * @returns {Component} the wrapped component and an 'unenabled' component
 */
const withFeatureFlagEnabled = (featureFlag: string) => {
  return (
    EnabledComponent: React.ComponentType<any>,
    UnenabledComponent: React.ComponentType<any>,
  ): React.ComponentType => {
    class withFeatureFlag extends React.Component<Props> {
      render() {
        const { isFeatureFlagEnabled, ...rest } = this.props;
        return isFeatureFlagEnabled ? (
          <EnabledComponent {...rest} />
        ) : (
          <UnenabledComponent {...rest} />
        );
      }
    }

    (
      withFeatureFlag as React.ComponentClass<Props>
    ).displayName = `WithFeatureFlag(${featureFlag})`;

    return connect<StoreProps, {}, OwnProps>(
      (store): StoreProps => ({
        isFeatureFlagEnabled:
          sessionSelector.isFeatureFlagEnabled(featureFlag)(store),
      }),
      {}, // mapDispatchToProps is a no-op to prevent leaking dispatch to children
    )(withFeatureFlag);
  };
};

export default withFeatureFlagEnabled;
